/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Timeline_Font_ColorInputs */



/**
* | output |
* | --- |
* | "Font Color" |
*
* @param {Options_Editor_Timeline_Font_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_timeline_font_color = /** @type {((inputs?: Options_Editor_Timeline_Font_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Timeline_Font_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur de police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftfarbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore del carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет шрифта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color de fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォント色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor da fonte")
	return /** @type {LocalizedString} */ ("Font Color")
});